export const SUPER_ADMIN_CONTROL_PLANE_ROOT =
  '/super-administrator/control-plane';
export const SUPER_ADMIN_CONTROL_PLANE_PAYMENTS =
  `${SUPER_ADMIN_CONTROL_PLANE_ROOT}/payments`;
export const SUPER_ADMIN_CONTROL_PLANE_INTEGRATIONS =
  `${SUPER_ADMIN_CONTROL_PLANE_ROOT}/integrations`;
export const SUPER_ADMIN_CONTROL_PLANE_ATTENDANCE =
  `${SUPER_ADMIN_CONTROL_PLANE_ROOT}/attendance`;
export const SUPER_ADMIN_CONTROL_PLANE_ASSISTANT_BRIDGE =
  `${SUPER_ADMIN_CONTROL_PLANE_ROOT}/assistant-bridge`;
export const SUPER_ADMIN_CONTROL_PLANE_ASSISTANT_WORKFLOWS =
  `${SUPER_ADMIN_CONTROL_PLANE_ROOT}/assistant-workflows`;
export const SUPER_ADMIN_CONTROL_PLANE_UI_CONSULTANT =
  `${SUPER_ADMIN_CONTROL_PLANE_ROOT}/ui-consultant`;
export const SUPER_ADMIN_CONTROL_PLANE_DC_CLEANUP =
  `${SUPER_ADMIN_CONTROL_PLANE_ROOT}/dc-cleanup`;

export const buildSuperAdminAssistantWorkflowPath = (
  workflowId: string,
): string =>
  `${SUPER_ADMIN_CONTROL_PLANE_ASSISTANT_WORKFLOWS}/${encodeURIComponent(workflowId || 'new')}`;

export const buildSuperAdminUiConsultantPath = (
  sessionId?: string,
): string =>
  sessionId
    ? `${SUPER_ADMIN_CONTROL_PLANE_UI_CONSULTANT}/${encodeURIComponent(sessionId)}`
    : SUPER_ADMIN_CONTROL_PLANE_UI_CONSULTANT;
